<script setup>
import { computed } from 'vue';

// Props.
const props = defineProps({
  modelValue: {
    type: [Array, Boolean],
  },
  value: {
    type: [Boolean, String, Number],
    default: '',
  },
  label: {
    type: String,
    default: '',
  },
  labelEn: {
    type: String,
    default: null,
  },
  icon: {
    type: String,
    default: '',
  },
  roundedIcon: {
    type: Boolean,
    default: false,
  },
});

// Events.
const emit = defineEmits(['update:modelValue']);

// Computed.
const model = computed({
  // This way the component will work for both boolean & array models.
  get() {
    return props.modelValue;
  },
  set(value) {
    emit('update:modelValue', value);
  },
});
</script>

<template>
  <div class="checkbox-toggle">
    <label>
      <input
        type="checkbox"
        :value="value"
        v-model="model"
        :data-label="labelEn ? labelEn : null"
        class="visually-hidden" />
      <span class="checkbox-toggle__toggle-outside">
        <span class="checkbox-toggle__toggle-inside"></span>
      </span>

      <!-- Icon (if any) & label (if any). -->
      <img
        v-if="icon"
        :src="icon"
        alt=""
        class="checkbox-toggle__icon"
        :class="{ 'checkbox-toggle__icon--rounded': roundedIcon }" />
      <template v-if="label">
        <!-- Labels may contain <sub></sub>. -->
        <span class="checkbox-toggle__label" v-html="label"></span>
      </template>
    </label>
  </div>
</template>
